import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import type { NationalityOutput } from 'types/api'

export const nationalitiesQueryKey = ['nationalities']

type UseNationalityArgs = {
  searchParams: string
}

export function useNationalities(args: UseNationalityArgs) {
  const { searchParams } = args

  const params = useMemo(
    function getParams(): URLSearchParams {
      const params = new URLSearchParams(searchParams)

      if (searchParams) {
        params.set('search', searchParams!)
      }

      return params
    },
    [searchParams]
  )

  async function getNationalities() {
    const response = await apiClient.get<NationalityOutput[]>(
      SNA_PREFIX + `nationalities?${params.toString()}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getNationalities,
    queryKey: [...nationalitiesQueryKey, params.toString()]
  })
}
